import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MapAlertPillProps {
  icon: LucideIcon;
  message: string;
  detail?: string | null | undefined;
  className?: string;
}

export function MapAlertPill({ icon: Icon, message, detail, className }: MapAlertPillProps) {
  return (
    <div className={cn('pointer-events-none absolute z-10 flex justify-center', className)}>
      <div className="flex min-w-0 items-center gap-2 rounded-full border border-danger-foreground/20 bg-danger py-1 pr-3 pl-1 text-danger-foreground shadow-sm motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-2">
        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-danger-foreground text-danger">
          <Icon className="size-3.5" aria-hidden />
        </span>
        <p className="min-w-0 truncate text-xs font-medium">
          {message}
          {detail && <span className="font-semibold"> · {detail}</span>}
        </p>
      </div>
    </div>
  );
}
